import { Component } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
	selector: 'app-request-support-button',
	templateUrl: './request-support-button.component.html',
	styleUrls: ['./request-support-button.component.scss'],
})
export class RequestSupportButtonComponent {
	supportLink: string = environment.requestSupportLink;
}